import styled from 'styled-components';

export const Container = styled.div``;

export const ModalContainer = styled.div`
  div.ModalBody {
    width: 480px;
    height: 120px;
    margin-top: 5px;
    margin-left: -24px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 47px 0 45px;
    background-color: #cedce0;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: 0.01px;
    color: #235f6e;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  padding: 10px 0;
  div.iconModal {
    width: 90px;
    height: 90px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    span {
      width: 50px;
      height: 50px;
      display: block;
      border-radius: 50%;
      background-color: #f7f7f7;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    svg {
      color: #235f6e;
    }
  }

  h2 {
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: 0.01px;
    text-align: left;
    color: #282828;
    span {
      color: #235f6e;
      font-weight: bold;
    }
  }
`;

export const ModalFooter = styled.div`
  width: 480px;
  margin-left: -24px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const ButtonModal = styled.button`
  width: 168.8px;
  height: 40.1px;
  border-radius: 3.5px;
  border: none;
  background-color: ${props => (props.cancel ? '#FFF' : '#74a50a')};
  color: ${props => (props.cancel ? '#999999' : '#f7f7f7')};
  margin: 20px 10px 0px 10px;
`;
